import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {BackToSiteButton} from '../../common/back-to-site-button'
import {Container} from '../common/container'
import {Title} from '../common/title'

export const LinkExpired = () => {
  const {t} = useTranslation()
  return (
    <Container dataHook="link-expired">
      <div style={{textAlign: 'center'}}>
        <Title text={t('linkExpired_title')} />
        <BackToSiteButton text={t('linkExpired_buttonText')} />
      </div>
    </Container>
  )
}
